import { Analytics } from "@vercel/analytics/react"
import './App.css';
import LLLogo from './Images/LLLogo.png';
import Magic from './Magic';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import React from 'react';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <nav className="navbar">
          <div className="navbar-container">
            <Link to="/" className="navbar-logo">
              <img src={LLLogo} alt="Laugh Letter Games" />
              Laugh Letter Games
            </Link>
            <ul className="navbar-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/magic">Magic</Link>
              </li>
            </ul>
          </div>
        </nav>

        {/* Routes */}
        <div className="main-content">
          <Routes>
            {/* Home Page */}
            <Route
              path="/"
              element={
                <div className="home">
                  <header className="App-header">
                    
                    <h1>Welcome to Laugh Letter Games!</h1>
                    <p>Explore and enjoy our games and resources.</p>
                    
                  </header>
                </div>
              }
            />

            {/* Magic Page */}
            <Route path="/magic" element={<Magic />} />
          </Routes>
        </div>
      </div>
      <Analytics />
    </Router>
  );
}

export default App;
